// Firebase UID → new app slug
// Add entries as each instructor is migrated to the new app.
// The slug's name portion can go stale if the instructor changes their name —
// the new app only uses the suffix for lookup and will canonicalize the URL.
export const MIGRATED_INSTRUCTORS: Record<string, string> = {
  // 'firebaseUid': 'name-slug-suffix',
  'test123': 'test-instructor-abc1',
  'test456': 'test-instructor-xyz2',
  'b9H6bfL0J7OtWxCLOidQRUnruwu2': 'devon-timson-fueb',
  'vGKK7IUMMKYMmLXQLGMgSoW76uw2': 'tony-brown-6r8p',
  'nkFNigEquigiUVfPRLqfHtYpgyo2': 'ben-van-deurzen-g404',
  'iN5ToNmhSnRoN1zxnwL6vQfQiTj2': 'rob-bernard-yujk',
  'b9W5I80HJzbXGMG28sSaSrlmP6P2': 'cameron-kyle-0103',
  'qW32Zrs1gZdByMCSTMILUWWFbMy1': 'ethan-morin-3i23',
  '9TOhWWKIYnS3mLNo1063R3hTCFr1': 'matt-zarowny-0sxw',
  '5N2rq0zukvS1bY6D1M7pWwgnMp13': 'deneb-rondinone-ebhz',
  'kRqTdgJx4dV14LXXK1uvMsop65f2': 'graeme-nelson-jhoa',
  '8xxQljw03sboGMydWKQT2L9sKr02': 'jason-wiwad-sas9',
  'JMMo5krzbHNFDHcZMEbNf1DTexp1': 'matt-mah-1vtm',
  'qgsjJA2hxscj5oJcNsVcv3YJIyi1': 'jeremy-lavallee-sfur',
  'QpZCFXD5NFWiUzhk2wsUBF1iqfv1': 'scott-lancaster-o2g7',
  'xUVxiDdbwefwvx2hvaiMYRnlK5p1': 'simon-butterfield-m9dh',
  'XheHbvHqM2WrXwuhgXmYzvDHMRM2': 'ben-rolph-pwmv',
  'oXadsYVHvlY38qbNSlLYHUv1fOk1': 'chris-horton-n5li',
  'zAZcwR9ag2Z4woFVgJKp0tYjobR2': 'jacob-dobbyn-ek81',
  '0S2GavmLxgR5J2sw3W6IeHKjbZJ2': 'fix-golf-g9h6',
  'B3B4wZAySGNkRHEgeauJX2aA8Bz1': 'khan-lee-9xme',
  'oMwYEPifPkODxYn2EptiHtRyoVL2': 'brian-bailer-l4il',
  'WZuQ2Q4kfigIv2pGWPUTp4dLAZC3': 'brett-buye-fc2g',
  'kV8HtG5k0dTCBr4VY4z3Q9L2upi2': 'gina-nelson-xdaa',
  'Sho7qzgkZZVc8VLrpvO7D4DovHG2': 'katrina-kelly-0g80',
  'LbiJ36mpHYbLwth0Luzo6ZQE8jy1': 'michelle-mccann-4708',
  'gDrUYoocQgSYgiZVZkojrLFodnv1': 'gert-myburgh-vcu8',
  'uZEct8P7OISXUAtjLo4uRgHF2FZ2': 'ben-stanbrough-2mwd',
  'r77Jyl1LpRVv0h5IYkQEBXGR8wU2': 'derek-kovacs-kreb',
  'DKYqiSidQgaadPFFH8gw8Ok5Hjm1': 'gage-murphy-gpsk',
  'S2SKbkb4nFcZ21qI0nSLvDOi6Wa2': 'kyle-boyd-p2jo',
  'bzfDbLeTPiVg5PuvNUm446xDo4B3': 'joey-busetto-x6sm',
  'DK2Unfk2pQOBupb32ZZbZMOadNA2': 'james-mcdonald-bj6y',
  'aUhTf9g4uEYMGsadw6aEmHbyLrI2': 'melissa-perron-jidk',
  'lcQycX5e9IdeFuuiftHZTnmAn792': 'mathew-macdonald-kjmd',
  '84NuLN1QdDa1QVd7gjAExY1eiPp1': 'reid-williamson-9rd2',
  'hajFmsW8MsaBbV9KiySc1aQu9j22': 'brendan-grabo-ivnd',
  'oEIIWQfxTaOd2psHXcJJu4jDJIj1': 'chris-otto-zylq',
  'STUV0eHu3qNEmvKCbhajTvlq1Be2': 'sullivan-gibb-ab06',
  '3dSFXCfcdUNRMse27JIOp8Sxgrv2': 'noah-kallichuk-pg0j',
  'RMNWibAcv2bXgYGGrLxtG7AAtKr1': 'kevin-chow-pu9q',
  'VNrFqybOlEWsVzseghyCJa5xb9J3': 'elizabeth-stewart-g28z',
  'TheqpJLPbkTjYUpc7oJEmWRuz713': 'matt-dykstra-hppj',
  'vlhSOm5WHabdrCezfWkrxX9JY8m1': 'aaron-cook-x9vc',
  '5RfwJN13LoVuWCihAoguyySogvG3': 'doug-denoon-fnyz',
}

export const NEW_APP_BASE_URL = 'https://app.swingmatchgolf.com'
